import { Observable, of } from 'rxjs';

export class MockData {
    getMock(url: string) {
        let result: any;
        switch (url) {
            case "/favcards": result = [
                {
                    id: 1,
                    cardTitle: "Card1",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: true,
                    surveyResults: "160 results"
                },
                {
                    id: 2,
                    cardTitle: "Card2",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: true,
                    surveyResults: "draft"
                }, 
                {
                    id: 3,
                    cardTitle: "Card3",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: true,
                    surveyResults: "22 results"
                }
            ];
                break;
            case "/mycards":result= [
                {
                    id: "1",
                    cardTitle: "Card1",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: true,
                    surveyResults: "160 reults"
                },
                {
                    id: "2",
                    cardTitle: "Card2",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: true,
                    surveyResults: "160 reults"
                }, {
                    id: "3",
                    cardTitle: "Card3",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: true,
                    surveyResults: "160 reults"
                },
                {
                    id: "4",
                    cardTitle: "Card4",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: false,
                    surveyResults: "160 reults"
                },
                {
                    id: "5",
                    cardTitle: "Card5",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: false,
                    surveyResults: "160 reults"
                },
                {
                    id: "6",
                    cardTitle: "Card6",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: false,
                    surveyResults: "160 reults"
                },
                {
                    id: "7",
                    cardTitle: "Card7",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: false,
                    surveyResults: "160 reults"
                },
                {
                    id: "8",
                    cardTitle: "Card8",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: false,
                    surveyResults: "160 reults"
                },
                {
                    id: "9",
                    cardTitle: "Card9",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: false,
                    surveyResults: "160 reults"
                },
                {
                    id: "10",
                    cardTitle: "Card10",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: false,
                    surveyResults: "160 reults"
                },
                {
                    id: "11",
                    cardTitle: "Card11",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: false,
                    surveyResults: "160 reults"
                },
                {
                    id: "12",
                    cardTitle: "Card12",
                    cardBody: "Lorem Ipsum Dolor Lorem Ipsum",
                    isFavourite: false,
                    surveyResults: "160 reults"
                }
            ];
                break;
            default:
                result= null; // If no URL is matched, return null    
        }
        return of(result); //return Observable of type 'result'
    }
}
